
import {Component, Vue} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import {getInvoiceBookingOrderProduct} from "@/api/invoice/index";
import {deepClone} from "@/utils/deepClone";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";

@Component({
  name: 'ProductItem',
  components: {Pagination}
})
export default class ProductItem extends Vue {

  public showProductItem = false;
  public loading = false;
  public tableCol = [
    {
      label: "报关品名",
      prop: "declarationDescription",
      key: "declarationDescription",
    },
    {
      label: "客户号码",
      prop: "guestModel",
      key: "guestModel",
    },
    {
      label: "华强号码",
      prop: "hqNumber",
      key: "hqNumber",
    },
    {
      label: "OE号码",
      prop: "oeNumber",
      key: "oeNumber",
    },
    {
      label: "REF",
      prop: "refNumber",
      key: "refNumber",
    },
    {
      label: "QTY",
      prop: "totalNumberPcs",
      key: "totalNumberPcs",
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
    },
    {
      label: "装箱单号",
      prop: "hqPackingListCode",
      key: "hqPackingListCode",
    },
    {
      label: "供应商简称",
      prop: "factoryAbb",
      key: "factoryAbb",
    },
    {
      label: "采购单价",
      prop: "poUnitPrice",
      key: "poUnitPrice",
    },
    {
      label: "采购折扣",
      prop: "poDiscount",
      key: "poDiscount",
    },
    {
      label: "开票单价",
      prop: "poDiscountUnitPrice",
      key: "poDiscountUnitPrice",
    },
    {
      label: "开票总金额",
      prop: "poTotalAmount",
      key: "poTotalAmount",
    },
  ]
  private table = {
    list: [] as any[],
  };
  private queryForm = {id: "", factoryName: "", productName: ""};

  private async getList() {
    this.loading = true;
    getInvoiceBookingOrderProduct(this.queryForm)
        .then(res => {
          this.table.list = res.sort((a, b) => {
            const factoryComparison = a.factoryAbb.localeCompare(b.factoryAbb);
            if (factoryComparison !== 0) {
              return factoryComparison;
            }
            return a.declarationDescription.localeCompare(b.declarationDescription);
          });
        })
        .finally(() => this.loading = false)
  }

  public handleDownload() {
    let list = deepClone(this.table.list);
    const headers = this.tableCol.map((v) => v.label);
    const fieldNames = this.tableCol.map((v) => v.key);
    exportJson2Excel(
        headers,
        formatJson(fieldNames, list),
        `报关产品详情-${new Date()}`
    );
  }

  public async openDialog(obj) {
    this.showProductItem = true;
    this.queryForm = {
      id: obj.id,
      factoryName: obj.factoryName,
      productName: obj.productName
    };
    this.getList()
  }
}
